import { render, staticRenderFns } from "./loginSSoPage.vue?vue&type=template&id=62dc54ec&scoped=true"
import script from "./loginSSoPage.vue?vue&type=script&lang=js"
export * from "./loginSSoPage.vue?vue&type=script&lang=js"
import style0 from "./loginSSoPage.vue?vue&type=style&index=0&id=62dc54ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dc54ec",
  null
  
)

export default component.exports